import { apiInstance, apiResponse, getLoadingState, ApiError } from '../../Api';

export const postDeposito = async (
  monografiaId: number, file: File, tipoDeposito: string): Promise<apiResponse<ApiError[]>> => {

  try {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('monografiaId', monografiaId.toString());
    formData.append('tipoDeposito', tipoDeposito);

    const fetchResponse = await apiInstance.post('/aluno/deposito', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });

    return {
      data: [],
      status: getLoadingState(fetchResponse.status)
    };

  } catch (e) {
    const status = e.response ? e.response.status : 500;
    return {
      data: e.response ? e.response.data : [],
      status: getLoadingState(status)
    };
  }
};

export const aprovarDeposito = async (depositoId: number): Promise<apiResponse<ApiError[]>> => {

  try {
    const fetchResponse = await apiInstance.post(
      '/professor/deposito/aprovar',
      { depositoId }
    );
    return {
      data: [],
      status: getLoadingState(fetchResponse.status)
    };
  } catch (e) {
    const status = e.response ? e.response.status : 500;

    return {
      data: e.response ? e.response.data : [],
      status: getLoadingState(status)
    };
  }
};

export const reprovarDeposito = async (
  depositoId: number, justificativa: string): Promise<apiResponse<ApiError[]>> => {

  try {
    const fetchResponse = await apiInstance.post(
      '/professor/deposito/reprovar',
      { depositoId, justificativa }
    );

    return {
      data: [],
      status: getLoadingState(fetchResponse.status)
    };
  } catch (e) {
    const status = e.response ? e.response.status : 500;
    return {
      data: e.response ? e.response.data : [],
      status: getLoadingState(status)
    };
  }
};
